module.exports = __webpack_public_path__ + "static/poster-ddd-01f1e77c72114797ff094ef42e82dbb0.jpg";